import { useCallback } from 'react';

import { FEATURE_FLAGS, FORM_TEMPLATE_PERMISSIONS } from '../helpers/constants';
import { checkUserPermissionOnTemplate } from '../helpers/utils';
import { usePlangridFeatureFlag } from '../PlangridLaunchDarklyProvider';

export default () => {
  const { value: isStatusExpansionEnabled } = usePlangridFeatureFlag(
    FEATURE_FLAGS.STATUS_EXPANSION,
    false,
  );

  return useCallback(
    (userPermissionInfo, template) => {
      let canManage = false;
      if (isStatusExpansionEnabled) {
        canManage = checkUserPermissionOnTemplate(
          userPermissionInfo,
          template,
          FORM_TEMPLATE_PERMISSIONS.MANAGE,
        );
      }

      return (
        canManage ||
        checkUserPermissionOnTemplate(
          userPermissionInfo,
          template,
          FORM_TEMPLATE_PERMISSIONS.SUBMIT,
        )
      );
    },
    [isStatusExpansionEnabled],
  );
};
